const DATE_FORMAT = "d. MMMM yyyy HH:mm";
const DATE_FORMAT_SHORT = "d. MMM yyyy";

export { DATE_FORMAT, DATE_FORMAT_SHORT };
